import { Navigate } from "react-router-dom";
import type { ReactElement } from 'react';

export default function LanguageGuard({
  children,
}: {
  children: ReactElement;
}) {
  const hasLang = localStorage.getItem('app_lang_selected') === 'true';

  if (!hasLang) {
    return <Navigate to="/language" replace />;
  }

  return children;
}
